import { render, staticRenderFns } from "./accident-report.vue?vue&type=template&id=4db7cecc&scoped=true&"
import script from "./accident-report.vue?vue&type=script&lang=js&"
export * from "./accident-report.vue?vue&type=script&lang=js&"
import style0 from "./accident-report.vue?vue&type=style&index=0&id=4db7cecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7cecc",
  null
  
)

export default component.exports